import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toolsData } from '../data/toolsData.js';
import { trackToolUsage } from '../utils/toolUsage.js';

const pathToToolId = new Map(toolsData.map((tool) => [tool.path, tool.id]));

const ToolUsageTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const toolId = pathToToolId.get(pathname);
    if (toolId) {
      trackToolUsage(toolId);
    }
  }, [pathname]);

  return null;
};

export default ToolUsageTracker;
